<div class="flex gap-2 cola-4">
    <span class="w-full input-field p-input-icon-right">
        <input pInputText placeholder="Código" [(ngModel)]="filters.code.value" (keydown.enter)="search()"
            class="w-full" />
        <i *ngIf="filters.code.value" class="pi pi-times cursor-pointer"
            (click)="filters.code.value = null; search()"></i>
    </span>
</div>

<p-table styleClass="mt-4" #grid [value]="transactions" [lazy]="true" (onLazyLoad)="loadData($event)" [loading]="loading"
    [paginator]="true" [rows]="25" [totalRecords]="totalRecords" [showCurrentPageReport]="true"
    currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
    [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" scrollHeight="flex" paginatorDropdownAppendTo="body">
    <ng-template pTemplate="header" let-columns>
        <tr>            
            <th pSortableColumn="code">Código <p-sortIcon field="code"></p-sortIcon></th>
            <th pSortableColumn="date">Fecha <p-sortIcon field="date"></p-sortIcon></th>   
            <th pSortableColumn="transactionState.name">Estado <p-sortIcon field="transactionState.name"></p-sortIcon></th>   
            <th pSortableColumn="thirdPartyId">{{transactionType.thirdPartyType == "Client"?"Cliente":
                transactionType.thirdPartyType == "Company"?"Compañía":
                transactionType.thirdPartyType == "Provider"?"Proveedor":"Operario"}} <p-sortIcon field="thirdPartyId"></p-sortIcon></th>   
            <th pSortableColumn="total">Total <p-sortIcon field="total"></p-sortIcon></th>   
            <th width="100"></th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-transaction let-columns="columns">
        <tr (dblclick)="edit(transaction)">            
            <td>{{transaction.code}}</td>
            <td>{{transaction.date | date:'dd/MM/yy'}}</td>
            <td>{{transaction.transactionState?.name}}</td>
            <td>{{transaction.thirdParty.name}}</td>
            <td>{{transaction.total | currency:'EUR'}}</td>
            <td>
                <div class="flex gap-2 justify-content-end">
                    <p-button *ngIf="allowDelete" (click)="delete(transaction)" [rounded]="true" [text]="false"
                        severity="danger"><i class="pi pi-trash"></i></p-button>
                    <p-button *ngIf="allowWrite" (click)="edit(transaction)" [rounded]="true" [text]="false"><i
                            class="pi pi-pencil"></i></p-button>
                </div>
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="6">        
             No se ha encontrado transacciones
          </td>
        </tr>
      </ng-template>
</p-table>

<p-confirmDialog></p-confirmDialog>